(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-avis-mur"] && !Shopify.designMode) return;
  try {
    (() => {
  const mq = window.matchMedia('(min-width: 750px)');
  function equiper(bloc) {
    if (bloc.dataset.rcAvisPret) return;
    bloc.dataset.rcAvisPret = '1';
    const piste = bloc.querySelector('.rc-avis__mur');
    if (!piste) return;
    const cartes = [...piste.children];
    const pas = parseInt(bloc.dataset.limite, 10) || 6;
    const boutons = bloc.querySelectorAll('[data-rc-avis-f]');
    const plus = bloc.querySelector('[data-rc-avis-plus]');
    const zonePlus = plus?.parentElement;
    let filtre = '';
    let n = pas;
    cartes.forEach((c) => c.classList.remove('rc-avis__carte--sup'));
    const choisies = () => cartes.filter((c) => !filtre || c.dataset.f === filtre);
    function animer(liste) { liste.forEach((c, i) => { c.style.setProperty('--i', i); c.classList.remove('is-in'); void c.offsetWidth; c.classList.add('is-in'); }); }
    function rendre(anime) {
      const L = choisies();
      const vis = mq.matches ? L.slice(0, n) : L;
      piste.replaceChildren(...vis);
      if (anime) animer(vis);
      if (zonePlus) zonePlus.hidden = !mq.matches || L.length <= n;
      piste.scrollLeft = 0;
      majRail();
    }
    /* Le rail commun (rc.js) se recalcule sur « scroll » : on le prévient après chaque changement de contenu. */
    function majRail() {
      piste.dispatchEvent(new Event('scroll'));
      setTimeout(() => piste.dispatchEvent(new Event('scroll')), 120);
    }
    boutons.forEach((b) => b.addEventListener('click', () => {
      filtre = b.dataset.rcAvisF || '';
      n = pas;
      boutons.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      rendre(true);
    }));
    plus?.addEventListener('click', () => {
      const L = choisies();
      const nouvelles = L.slice(n, n + pas);
      n += pas;
      piste.append(...nouvelles);
      animer(nouvelles);
      if (zonePlus) zonePlus.hidden = L.length <= n;
      nouvelles[0]?.setAttribute('tabindex', '-1');
      nouvelles[0]?.focus({ preventScroll: true });
    });
    mq.addEventListener('change', () => rendre(false));
    rendre(false);
  }
  const tout = (r) => r.querySelectorAll('[data-rc-avis]').forEach(equiper);
  tout(document);
  document.addEventListener('shopify:section:load', (e) => tout(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-collection-grille"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.RCCol) return;
    var RCCol = (window.RCCol = {});
    var PRIX_DELAI = 700;

    function racine(el) { return el && el.closest ? el.closest('[data-rc-col]') : null; }
    function partie(doc, nom) { return doc.querySelector('[data-rc-col-part="' + nom + '"]'); }
    function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
    function apparaitre(el) {
      if (window.RC && typeof window.RC.equiper === 'function') window.RC.equiper(el);
      else el.querySelectorAll('.rc-reveal').forEach(function (x) { x.classList.add('is-vu'); });
    }

    /* Hauteur de l'en-tête collant : la colonne de filtres colle juste dessous. */
    function caler(root) {
      var h = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) {
        var pos = getComputedStyle(s).position;
        if (pos === 'sticky' || pos === 'fixed') h += s.offsetHeight;
      });
      root.style.setProperty('--rc-col-haut', (h + 16) + 'px');
    }

    function urlForm(root) {
      var form = root.querySelector('[data-rc-colf-form]');
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var s = p.toString();
      return form.getAttribute('action') + (s ? '?' + s : '');
    }

    function equiperParties(root) {
      root.querySelectorAll('[data-rc-colf-encore]').forEach(function (b) {
        var g = b.closest('.rc-colf__groupe');
        var tout = g && g.classList.contains('is-tout');
        b.hidden = false;
        b.setAttribute('aria-expanded', tout ? 'true' : 'false');
        b.querySelector('[data-plus]').hidden = tout;
        b.querySelector('[data-moins]').hidden = !tout;
      });
    }

    function charger(root, url) {
      var u = new URL(url, location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      var f = new URL(u.href);
      f.searchParams.set('section_id', root.dataset.section);
      if (root._ctrl) root._ctrl.abort();
      var ctrl = (root._ctrl = new AbortController());
      root.classList.add('is-charge');
      return fetch(f.href, { signal: ctrl.signal, headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = parse(html);
          var etat = {};
          root.querySelectorAll('.rc-colf__groupe').forEach(function (d) { etat[d.dataset.cle] = { open: d.open, tout: d.classList.contains('is-tout') }; });
          var actif = document.activeElement;
          var cible = null;
          if (actif && root.contains(actif) && actif.name) {
            cible = '[name="' + CSS.escape(actif.name) + '"]';
            if (actif.type === 'checkbox') cible += '[value="' + CSS.escape(actif.value) + '"]';
          } else if (actif && actif.matches && actif.matches('[data-rc-col-lien]')) {
            cible = '[data-rc-colf-ouvrir]';
          }
          root.querySelectorAll('[data-rc-col-part]').forEach(function (p) {
            var n = partie(doc, p.dataset.rcColPart);
            if (n) p.replaceWith(n);
          });
          root.querySelectorAll('.rc-colf__groupe').forEach(function (d) {
            var e = etat[d.dataset.cle];
            if (e) { d.open = e.open; d.classList.toggle('is-tout', e.tout); }
          });
          equiperParties(root);
          if (cible) {
            var el = root.querySelector(cible);
            if (el && el.offsetParent !== null) el.focus({ preventScroll: true });
          }
          history.replaceState(history.state, '', u.pathname + u.search + u.hash);
          apparaitre(root);
          var aside = root.querySelector('[data-rc-colf]');
          if (!(aside && aside.classList.contains('is-ouvert'))) {
            var haut = root.getBoundingClientRect().top;
            if (haut < 0) window.scrollBy({ top: haut - 90, behavior: 'smooth' });
          }
        })
        .catch(function (e) { if (e.name !== 'AbortError') location.href = u.href; })
        .finally(function () { if (root._ctrl === ctrl) root.classList.remove('is-charge'); });
    }

    function plus(root, a) {
      var f = new URL(a.href, location.href);
      f.searchParams.set('section_id', root.dataset.section);
      a.classList.add('is-loading');
      a.setAttribute('aria-busy', 'true');
      fetch(f.href, { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = parse(html);
          var grille = root.querySelector('[data-rc-col-grille]');
          var neuve = partie(doc, 'grille');
          var premier = null;
          if (neuve) {
            Array.prototype.slice.call(neuve.children).forEach(function (it) {
              if (!it.classList.contains('rc-col__item')) return;
              grille.appendChild(it);
              if (!premier) premier = it;
            });
          }
          var p = partie(doc, 'plus');
          var actuel = root.querySelector('[data-rc-col-part="plus"]');
          if (p && actuel) actuel.replaceWith(p);
          apparaitre(root);
          var lien = premier && premier.querySelector('.rc-card__nom');
          if (lien) lien.focus({ preventScroll: true });
        })
        .catch(function () { location.href = a.href; });
    }

    /* Panneau mobile */
    var dernierOuvreur = null;
    function ouvrir(root, bouton) {
      var aside = root.querySelector('[data-rc-colf]');
      if (!aside) return;
      dernierOuvreur = bouton || null;
      aside.classList.add('is-ouvert');
      aside.setAttribute('role', 'dialog');
      aside.setAttribute('aria-modal', 'true');
      document.body.classList.add('overflow-hidden');
      root.querySelectorAll('[data-rc-colf-ouvrir]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var fermer = aside.querySelector('.rc-colf__fermer');
      if (fermer) setTimeout(function () { fermer.focus(); }, 60);
    }
    function fermer(root) {
      var aside = root.querySelector('[data-rc-colf]');
      if (!aside || !aside.classList.contains('is-ouvert')) return;
      aside.classList.remove('is-ouvert');
      aside.removeAttribute('role');
      aside.removeAttribute('aria-modal');
      document.body.classList.remove('overflow-hidden');
      root.querySelectorAll('[data-rc-colf-ouvrir]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var b = dernierOuvreur || root.querySelector('[data-rc-colf-ouvrir]');
      if (b) b.focus({ preventScroll: true });
    }

    var minuteur;
    document.addEventListener('change', function (e) {
      var root = racine(e.target);
      if (!root) return;
      if (e.target.matches('[data-rc-colf-prix]')) return; /* géré par « input » */
      if (e.target.closest('[data-rc-colf-form]') || e.target.matches('[data-rc-col-tri]')) charger(root, urlForm(root));
    });
    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('[data-rc-colf-prix]')) return;
      var root = racine(e.target);
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { charger(root, urlForm(root)); }, PRIX_DELAI);
    });
    document.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-rc-colf-form]')) return;
      var root = racine(e.target);
      if (!root) return;
      e.preventDefault();
      clearTimeout(minuteur);
      charger(root, urlForm(root));
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-rc-col-lien],[data-rc-col-plus],[data-rc-colf-ouvrir],[data-rc-colf-fermer],[data-rc-colf-encore]');
      if (!t) return;
      var root = racine(t);
      if (!root) return;
      if (t.matches('[data-rc-col-lien]')) { e.preventDefault(); charger(root, t.href); }
      else if (t.matches('[data-rc-col-plus]')) { e.preventDefault(); plus(root, t); }
      else if (t.matches('[data-rc-colf-ouvrir]')) { e.preventDefault(); ouvrir(root, t); }
      else if (t.matches('[data-rc-colf-fermer]')) { e.preventDefault(); fermer(root); }
      else if (t.matches('[data-rc-colf-encore]')) {
        var g = t.closest('.rc-colf__groupe');
        g.classList.toggle('is-tout');
        equiperParties(root);
      }
    });
    document.addEventListener('keydown', function (e) {
      var ouvert = document.querySelector('[data-rc-colf].is-ouvert');
      if (!ouvert) return;
      var root = racine(ouvert);
      if (e.key === 'Escape') { fermer(root); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(ouvert.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,summary'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
    var mq = window.matchMedia('(min-width: 990px)');
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () {
      if (mq.matches) document.querySelectorAll('[data-rc-col]').forEach(fermer);
    });

    function init(scope) {
      (scope || document).querySelectorAll('[data-rc-col]').forEach(function (root) {
        root.classList.add('rc-js');
        caler(root);
        equiperParties(root);
      });
    }
    RCCol.init = init;
    RCCol.charger = charger;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    window.addEventListener('resize', function () { document.querySelectorAll('[data-rc-col]').forEach(caler); }, { passive: true });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
